import React, { useEffect, useState } from 'react';
import { Button, Grid, Paper } from '@material-ui/core';
import { LibraryItem } from './LibraryItem';
import MyDialog2 from './MyDialog2';
import ExpertService from '../../services/expert.service';

import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { IconButton } from '@material-ui/core';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // I
import expertService from '../../services/expert.service';

interface LibraryItemIntprProps {
    libraryId: number;
    item: LibraryItem;
    onSave: (id: number, text: string) => void;
    onDelete: () => void;
    onCancel: () => void;
    style?: React.CSSProperties;
}

function LibraryItemIntpr(props: LibraryItemIntprProps) {
    const [item, setItem] = useState<LibraryItem>(props.item);
    const [open, setOpen] = useState<boolean>(false);
    const [expertId, setExpertId] = useState<number>(0);

    useEffect(() => {
        const userStr = localStorage.getItem('user');
        const expertId1 = userStr !== null ? JSON.parse(userStr).user_info.expid : 0;
        setExpertId(expertId1);
        //eslint-disable-next-line
    });

    const onSave = () => {
        if (item.Id > 0)
            try {
                if (
                    item.InterpretationId != null &&
                    item.InterpretationId > 0 &&
                    (item.Interpretation == null || item.Interpretation.length == 0)
                )
                    ExpertService.deleteInterpretation(item.Id, expertId).then(response => {
                        props.onSave(0, '');
                    });
                else
                    ExpertService.updateInterpretation(
                        props.libraryId,
                        item.Id,
                        expertId,
                        item.Interpretation ? item.Interpretation : '',
                        item.InterpretationId
                    ).then(response => {
                        props.onSave(response.id, item.Interpretation ? item.Interpretation : '');
                    });
            } catch (error) {
                debugger;
            }
    };

    const onDelete = () => {
        expertService.deleteInterpretation(item.Id, expertId).then(response => {
            props.onDelete();
        });
    };
    const customToolbar = [
        ['bold', 'italic', 'underline'], // text formatting
        ['link'], // links
        [{ list: 'bullet' }], // bullet list
        [{ script: 'sub' }, { script: 'super' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ color: [] }, { background: [] }],
        ['clean']
    ];

    return (
        <div style={{ ...props.style, alignItems: 'start' }}>
            <IconButton style={{ padding: '5px' }} onClick={() => setOpen(true)}>
                {item.Interpretation == null || item.Interpretation.length == 0 ? (
                    <AddIcon fontSize="small" />
                ) : (
                    <EditIcon fontSize="small" />
                )}{' '}
            </IconButton>
            <MyDialog2
                key={`LibraryItemInterpretationDialog${props.item.Id}`}
                style={{ display: 'inline-block' }}
                title="Library Item - Interpretation"
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
            >
                <div style={{ height: '500px', textAlign: 'left', paddingTop: '0px' }}>
                    <Paper style={{ padding: 16 }}>
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12}></Grid>
                            <Grid item xs={12}>
                                <ReactQuill
                                    theme="snow"
                                    value={item.Interpretation}
                                    onChange={e => setItem({ ...item, Interpretation: e })}
                                    style={{ width: '100%', height: '300px' }}
                                    modules={{ toolbar: customToolbar }}
                                />
                            </Grid>
                            <Grid item style={{ marginTop: 40 }}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                        setOpen(false);
                                        props.onCancel();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item style={{ marginTop: 40 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => {
                                        setOpen(false);
                                        onSave();
                                    }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                            {props.item.Interpretation !== null && (
                                <Grid item style={{ marginTop: 40, marginLeft: 'auto' }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            setOpen(false);
                                            onDelete();
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Paper>
                </div>
            </MyDialog2>
        </div>
    );
}

export default LibraryItemIntpr;
